/* eslint-disable no-nested-ternary */
import React from 'react';
import './pagination.css';

const Pagination = ({
  totalPosts,
  postsPerPage,
  setCurrentPage,
  currentPage,
}) => {
  const pages = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i += 1) {
    pages.push(i);
  }
  console.log(pages.length, 'pages');
  return (
    <div>
      {pages.length > 1 && (
        <div className='pagination pb-4'>
          {pages.slice(0, 3).map((page) => (
            <button
              // key={index}
              type='button'
              onClick={() => setCurrentPage(page)}
              className={page === currentPage ? 'active' : ''}
            >
              {page}
            </button>
          ))}
          <span className='text-white flex items-end'>.....</span>
          {currentPage > 4
            ? pages.slice(currentPage - 2, currentPage + 1).map((page) => (
                <button
                  // key={index}
                  type='button'
                  onClick={() => setCurrentPage(page)}
                  className={page === currentPage ? 'active' : ''}
                >
                  {page}
                </button>
              ))
            : currentPage === 4
            ? pages.slice(3, 6).map((page) => (
                <button
                  // key={index}
                  type='button'
                  onClick={() => setCurrentPage(page)}
                  className={page === currentPage ? 'active' : ''}
                >
                  {page}
                </button>
              ))
            : pages.slice(3, 5).map((page) => (
                <button
                  // key={index}
                  type='button'
                  onClick={() => setCurrentPage(page)}
                  className={page === currentPage ? 'active' : ''}
                >
                  {page}
                </button>
              ))}
          {/* pagination palaweni values 3ta wada next page eka wedi nm, e pages eka
      ita kalin page eka passe eka wenama pennanawa. */}
          <span className='text-white flex items-end'>.....</span>
          {pages.slice(Math.max(pages.length - 3, 0)).map((page) => (
            <button
              // key={index}
              type='button'
              onClick={() => setCurrentPage(page)}
              className={page === currentPage ? 'active' : ''}
            >
              {page}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Pagination;
